import { v4 as uuid } from 'uuid';
/**
 * Represents a request to send message a {@link ChatRoom | chat room}.
 *
 * @remarks
 *   Sending this request to a chat room requires SEND_MESSAGE capability encoded in chat token. Otherwise, server will
 *   respond with error code 403 ({@link chatErrorCodes}).
 */
export class SendMessageRequest {
    /**
     * Constructs a {@link SendMessageRequest } instance.
     *
     * @param content - Message to be sent
     * @param attributes - Key-value object for any additional data
     */
    constructor(content, attributes) {
        this.action = 'SEND_MESSAGE';
        this.requestId = uuid();
        this.content = content;
        this.attributes = attributes;
    }
}
//# sourceMappingURL=SendMessageRequest.js.map